import Team from "@mapmycustomers/shared/types/Team";
import User from "@mapmycustomers/shared/types/User";

import Scope from "@app/types/dashboard/Scope";

import scopeToFilter from "./scopeToFilter";

interface ScopedSettingsRow {
  teamId: null | Team["id"];
  userId: null | User["id"];
}

// Field Insights settings rows are keyed on the slot the GET filter and payload
// use: userId wins, teamId drops to null. Two reasons never to take data[0]:
// reading raw scope.teamId misses the row for a user viewed under a team (scope
// carries both ids), and the org-level filter is empty — `$and: []` sends no
// filter at all, so the list comes back holding every row in the org.
const findScopedSettingsRow = <T extends ScopedSettingsRow>(rows: T[], scope: Scope): null | T => {
  const { teamId: targetTeamId = null, userId: targetUserId = null } = scopeToFilter(scope);
  return (
    rows.find(
      (row) => (row.userId ?? null) === targetUserId && (row.teamId ?? null) === targetTeamId
    ) ?? null
  );
};

export default findScopedSettingsRow;
